/* eslint-disable no-unused-vars */
import React, { useCallback } from 'react';
import Modal from './index';
import style from './modal.module.scss';
import size from 'lodash-es/size';
import each from 'lodash-es/each';
import { map } from 'lodash-es';
import Button from 'controls/buttons/submit';
import { Status } from 'store/types';
import LinearProgressComponent from 'components/progress/progress';
import {
  useRegisterKeyHandler,
  useUniqueKeyHandler,
} from 'hooks/useKeyHandler';
import { getDeclension } from 'utils/utils';

export type ProgressItem = {
  id: string;
  status: Status;
  percent: number;
  description?: string;
};

export type ProgressItems = {
  [id: string]: ProgressItem;
};

export default function ProgressModal({
  onContinue,
  onAgain,
  progressItems,
}: {
  onContinue: () => void;
  onAgain: () => void;
  progressItems: ProgressItems;
}) {
  const amount = {
    pending: 0,
    rejected: 0,
    fulfilled: 0,
    all: size(progressItems),
  };

  each(progressItems, (item) => {
    amount[item.status] += 1;
  });

  const processed = amount.rejected + amount.fulfilled;
  const isFinished = processed === amount.all;

  const keyHandlerId = useUniqueKeyHandler();
  const keyHandler = useCallback(
    (e: KeyboardEvent) => {
      switch (e.code) {
        case 'Enter':
          e.preventDefault();
          e.stopPropagation();
          if (!isFinished) {
            return;
          }
          onContinue();
          break;
      }
    },
    [onContinue, isFinished]
  );
  useRegisterKeyHandler({
    handler: keyHandler,
    id: keyHandlerId,
  });

  return (
    <Modal open={true} disableClose={true}>
      <div className={style.modalScrollWrapper}>
        <div className={style.progress}>
          <span className={style.mainText}>
            {isFinished
              ? 'Загрузка завершена'
              : 'Выполняется загрузка, пожалуйста подождите'}
          </span>

          <div className={style.details}>
            {map(progressItems, (item) => {
              return (
                <LinearProgressComponent
                  key={item.id}
                  {...item}
                ></LinearProgressComponent>
              );
            })}
          </div>

          {isFinished ? (
            <div className={style.finished}>
              <span className={style.result}>
                {`${getDeclension(amount.fulfilled, [
                  'Загружен',
                  'Загружено',
                  'Загружено',
                ])} ${amount.fulfilled} ${getDeclension(amount.fulfilled, [
                  'файл',
                  'файла',
                  'файлов',
                ])} из ${amount.all}`}
              </span>

              <div className={style.buttons}>
                <Button className={style.close} onClick={onContinue}>
                  Готово
                </Button>
                <Button
                  className={style.close}
                  variant={'outlined'}
                  onClick={onAgain}
                >
                  Загрузить еще
                </Button>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </Modal>
  );
}
